import React from 'react';
import { SubTitle, Title, ModalContainer } from './style';
import { ICancelPaymentModal } from '../interface';
import { CANCEL_PAYMENT_MODAL } from '../constants';
import { CommonButton } from '@Components';

const CancelPaymentModal: React.FC<ICancelPaymentModal> = (props) => {
  return (
    <ModalContainer gap={'24px'}>
      <Title>{CANCEL_PAYMENT_MODAL.heading}</Title>
      <SubTitle>
        {props.postPan ? CANCEL_PAYMENT_MODAL.subHeading48hrs : CANCEL_PAYMENT_MODAL.subHeading}
      </SubTitle>
      <CommonButton
        text={CANCEL_PAYMENT_MODAL.continueButtonMsg}
        onClick={props.onContinue}
        type="primary"
        width={450}
      />
      <CommonButton
        text={CANCEL_PAYMENT_MODAL.confirmButtonMsg}
        onClick={props.onConfirm}
        type="secondary"
        width={450}
      />
    </ModalContainer>
  );
};

export default CancelPaymentModal;
